var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0121 25.7956C32.0013 23.8116 32.8986 22.3142 34.715 21.2114C33.6987 19.7573 32.1635 18.9572 30.1363 18.8004C28.2172 18.6491 26.1198 19.9194 25.3521 19.9194C24.5413 19.9194 22.6817 18.8545 21.2221 18.8545C18.2056 18.9031 15 21.2601 15 26.055C15 27.4714 15.2595 28.9345 15.7784 30.4446C16.4704 32.4285 18.9679 37.2937 21.5735 37.2126C22.9357 37.1802 23.898 36.245 25.6711 36.245C27.3901 36.245 28.2821 37.2126 29.8011 37.2126C32.4283 37.1748 34.688 32.7528 35.3475 30.7635C31.8229 29.1039 32.0121 25.8983 32.0121 25.7956ZM28.9524 16.9192C30.4282 15.1677 30.293 13.573 30.2498 13C28.947 13.0757 27.4388 13.8866 26.5793 14.8866C25.6332 15.957 25.0764 17.2814 25.1954 18.7734C26.6063 18.8815 27.8929 18.1571 28.9524 16.9192Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleLogin);
export default __webpack_public_path__ + "static/media/apple-login.a61eaeb39ee2b026105597e9518a2e50.svg";
export { ForwardRef as ReactComponent };